import * as apiFactory from "./ApiFactory";
import { Api } from "./Api";
import { useBrandStore } from "@/stores/brand-store";

import type CaseViewerConfig from "@/models/CaseViewerConfig";

export async function Get(clientName: string, brand: string, caseReference: string): Promise<CaseViewerConfig> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<CaseViewerConfig>(["api/caseclientuiconfig", clientName, brand, caseReference]);
}

export async function Save(
  clientName: string,
  brand: string,
  caseReference: string,
  value: CaseViewerConfig,
): Promise<void> {
  const client: Api = await apiFactory.WithBearer();

  const options: string[] = useBrandStore().viewerConfig.timeline?.upper?.periodOptions.map((m) => m.name) ?? [];

  value.agreementPeriods.forEach((p) => {
    options.forEach((o: string) => {
      const period = value.agreementPeriods.find((f) => f.id === p.id);
      if (period) {
        p[o] = period[o];
      }
    });
  });

  await client.post<CaseViewerConfig, void>(["api/caseclientuiconfig", clientName, brand, caseReference], value);
}
